import { useUIContext } from 'lib/context/UIContext/UIContext';
import { cn, ia } from 'lib/helpers/utility';

import Button from 'components/shared/Button/Button';
import Typography from 'components/shared/Typography/Typography';

import TableCell from './TableCell';

const TableRowDesktop = ({
  columnDefs,
  row,
  idx,
  className,
  style,
  cellClassName,
  cellStyle,
  isExpanded,
  handleExpand,
  small,
  preview,
  depth = 1
}) => {
  const lastIdx = columnDefs.length - 1;
  const isLast = idx === lastIdx;

  const { device } = useUIContext();
  const isMobile = device === 'tablet-sm' || device === 'mobile';

  if (isMobile) return null;

  return (
    <tr
      key={idx}
      className={cn(
        'h-8 w-fit border-0',
        !isLast && 'border-b border-solid border-white',
        className
      )}
      style={style}>
      {columnDefs.map((col, index) => {
        let value = row?.[col?.field];
        if (col.valueFormatter)
          value = col.valueFormatter({ value, data: row, rowIdx: idx, colDef: col });
        if (col.cellRenderer)
          value = col.cellRenderer({ value, data: row, rowIdx: idx, colDef: col });

        return (
          <TableCell
            key={String(col.field)}
            index={index}
            lastIdx={lastIdx}
            depth={depth}
            preview={preview}
            className={cn(index === 0 && ia(row.children) && 'pl-2', cellClassName, col?.cellClass)}
            style={cellStyle}>
            <div className="flex items-start">
              {index === 0 && ia(row.children) && (
                <Button
                  variant="link"
                  size="small"
                  icon="chevron-up-linear"
                  iconSize={18}
                  iconColor="neutral"
                  className={cn(
                    'h-fit w-fit self-center transition-transform duration-200',
                    isExpanded && 'rotate-180',
                    !row.is_detailed && 'hidden'
                  )}
                  onClick={handleExpand}
                />
              )}
              <Typography variant={small ? 'p' : 'label'} size={small ? 'xs' : 'medium'}>
                {value}
              </Typography>
            </div>
          </TableCell>
        );
      })}
    </tr>
  );
};

export default TableRowDesktop;
